// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__XLJKG","loadingSpinner":"LoadingSpinner_loadingSpinner__mBoi2","spinner":"LoadingSpinner_spinner__CgHfL"};